var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _path11, _path12, _path13, _path14, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataSynthesis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9982 24V24.455C33.9982 25.2057 33.3759 25.8199 32.6153 25.8199H5.87902C5.11841 25.8199 4.49609 25.2057 4.49609 24.455C4.49609 24.2037 4.6998 24 4.95108 24H33.9982Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.332061,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.013 24.0449C22.013 24.3094 21.7134 24.5116 21.3216 24.5116H17.1729C16.7811 24.5116 16.4814 24.3094 16.4814 24.0449",
    fill: "#191919"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.013 24.0449C22.013 24.3094 21.7134 24.5116 21.3216 24.5116H17.1729C16.7811 24.5116 16.4814 24.3094 16.4814 24.0449",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18367 7H19.2469H30.3102C30.8173 7 31.2322 7.41351 31.2322 7.91896V15.9598V23.1704C31.2322 23.6289 30.8605 24.0005 30.402 24.0005H8.09187C7.63339 24.0005 7.26172 23.6289 7.26172 23.1704V7.9189C7.26178 7.41351 7.67664 7 8.18367 7Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.90484 7.8418H19.2472H29.5895C30.0635 7.8418 30.4513 8.20854 30.4513 8.65682V15.7882V22.9196H8.04297V8.65677C8.04302 8.20854 8.43085 7.8418 8.90484 7.8418Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8496 17.127L23.4967 17.127C23.6667 17.127 23.8325 17.1791 23.9719 17.2764L26.4869 19.0317",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2227 15.127C22.5412 15.127 25.6958 15.127 25.6958 15.127",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4336 10.5957L24.5121 10.5957",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2978 13.0842L23.4263 13.0842C23.5998 13.0842 23.769 13.0298 23.91 12.9287L26.6521 10.9629",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4336 20.3809L23.873 20.3809",
    stroke: "black",
    strokeWidth: 0.332061
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.512,
    cy: 20.3812,
    r: 0.638986,
    fill: "#191919",
    stroke: "black",
    strokeWidth: 0.332061
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8968,
    cy: 19.4261,
    r: 0.638986,
    fill: "#191919",
    stroke: "black",
    strokeWidth: 0.332061
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.3216,
    cy: 15.1273,
    r: 0.638986,
    fill: "#191919",
    stroke: "black",
    strokeWidth: 0.332061
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.8989,
    cy: 10.6274,
    r: 0.639109,
    fill: "#191919",
    stroke: "black",
    strokeWidth: 0.332061
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5122,
    cy: 10.5043,
    r: 0.639109,
    fill: "#191919",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.43 9.59183C18.43 9.40844 18.2813 9.25977 18.0979 9.25977L17.4129 9.25977C17.3344 9.25977 16.8951 10.4064 16.7439 10.8071C16.711 10.8943 16.6436 10.9633 16.5572 10.9983L16.0559 11.2015C15.9741 11.2347 15.8833 11.2342 15.8019 11.2001C15.4078 11.0348 14.2233 10.5441 14.1692 10.5958L13.197 11.5476C13.1416 11.6025 13.6569 12.7132 13.8404 13.1031C13.8807 13.1888 13.8827 13.287 13.846 13.3743L13.6432 13.8568C13.6081 13.9401 13.5414 14.0053 13.4571 14.0381C13.0557 14.1945 11.8711 14.6625 11.8711 14.7375L11.8711 16.0828C11.8711 16.1594 13.0483 16.5915 13.4556 16.7387C13.5432 16.7704 13.613 16.8367 13.6492 16.9225L13.8524 17.4034C13.8881 17.4879 13.8876 17.5826 13.8508 17.6666C13.6789 18.0593 13.1843 19.2043 13.2376 19.2571L14.2109 20.2078C14.2652 20.2611 15.4148 19.7504 15.8067 19.574C15.89 19.5366 15.9842 19.5349 16.0688 19.5693L16.5717 19.7736C16.655 19.8074 16.7208 19.8729 16.7548 19.9562C16.9156 20.3498 17.3939 21.5044 17.4708 21.5044L18.0979 21.5044C18.2813 21.5044 18.4299 21.3557 18.4299 21.1723L18.4299 19.7755C18.4299 19.5819 18.2651 19.4295 18.0721 19.4153C16.6936 19.3143 14.32 18.1631 14.32 15.3937C14.32 12.6059 16.6624 11.4421 18.0845 11.3199C18.2728 11.3037 18.4299 11.1535 18.4299 10.9645L18.43 9.59183Z",
    fill: "#E3D6C7",
    stroke: "black",
    strokeWidth: 0.332061
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.342 13.5539C17.3318 13.5539 16.5129 14.3728 16.5129 15.383C16.5129 16.3932 17.3318 17.2121 18.342 17.2121C19.3522 17.2121 20.1711 16.3932 20.1711 15.383C20.1711 14.3728 19.3522 13.5539 18.342 13.5539ZM15.1523 15.383C15.1523 13.6214 16.5804 12.1934 18.342 12.1934C20.1036 12.1934 21.5316 13.6214 21.5316 15.383C21.5316 17.1446 20.1036 18.5727 18.342 18.5727C16.5804 18.5727 15.1523 17.1446 15.1523 15.383Z",
    fill: "#191919"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6073 28.9072C14.1672 31.6557 4.56917 30.8482 4.00906 28.8769C4.00229 28.853 4 28.8289 4 28.8041V25.4139V21.3018V17.0371C4 16.8537 4.14867 16.7051 4.33206 16.7051H15.3077C15.4911 16.7051 15.6398 16.8537 15.6398 17.0371V21.4917V25.4139V28.7677C15.6398 28.8163 15.6298 28.8641 15.6073 28.9072Z",
    fill: "#E3D6C7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.3018V17.0371C4 16.8537 4.14867 16.7051 4.33206 16.7051H15.3077C15.4911 16.7051 15.6398 16.8537 15.6398 17.0371V21.4917M4 21.3018C5.59727 23.1527 13.2851 23.8285 15.6398 21.4917M4 21.3018V25.4139M15.6398 21.4917V25.4139M4 25.4139V28.8041C4 28.8289 4.00229 28.853 4.00906 28.8769C4.56917 30.8482 14.1672 31.6557 15.6073 28.9072C15.6298 28.8641 15.6398 28.8163 15.6398 28.7677V25.4139M4 25.4139C5.94181 27.0175 13.243 27.4924 15.6398 25.4139",
    stroke: "black",
    strokeWidth: 0.332061
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.8191,
    cy: 16.8748,
    rx: 5.8191,
    ry: 2.30837,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.332061
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6821,
    cy: 24.4881,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.1782,
    cy: 24.2752,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.5219,
    cy: 23.8377,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.4252,
    cy: 20.9392,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.9213,
    cy: 20.7263,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.2641,
    cy: 20.2888,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.8725,
    cy: 28.5388,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3686,
    cy: 28.326,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.7114,
    cy: 27.8885,
    rx: 0.447685,
    ry: 0.419705,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSynthesis);
export default __webpack_public_path__ + "static/media/DataSynthesis.d93b348c6c5bf399b0d74a5392714108.svg";
export { ForwardRef as ReactComponent };